var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"data-luko-tracking":"Page-Advice"}},[_c('AdvicesHubModule',{attrs:{"module-data":{ hubSlices: _vm.hubSlices, article: [], allCategories: _vm.allCategories }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }